module.exports = __webpack_public_path__ + "static/media/Severus Snape 3.d06991c9.jpg";